import { render, staticRenderFns } from "./Carrousel.vue?vue&type=template&id=03c704c9&scoped=true"
import script from "./Carrousel.vue?vue&type=script&lang=js"
export * from "./Carrousel.vue?vue&type=script&lang=js"
import style0 from "./Carrousel.vue?vue&type=style&index=0&id=03c704c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c704c9",
  null
  
)

export default component.exports